module.exports = __webpack_public_path__ + "static/media/sacred_img.a2ad0bb3.jpg";